import { store } from "common/store";
import { v2 } from "common/config/api";

import { request, makeMarionetteAbortableRequest } from "common/components/request";

export const FETCH_ANALYTICS_DATA = function({
    url, start, end, datetype, q, freq = "day", view = void 0
}) {
    const state = store.getState();
    
    return makeMarionetteAbortableRequest({
        url,
        view,
        data: {
            start,
            end,
            freq,
            datetype: state.common.date_range.datetype,
            currency: state.common.currency,
            q: q.toString(true)
        }
    });
};

export const FETCH_TRANSACTIONS = ({ url, ...params }) => request(url, {
    data: { ...params }
});

export const FETCH_SETTLEMENT_STATUS_DATA = function({ start, end, datetype = "activity", q }) {
    const state = store.getState();
    
    return request(v2.settlements.byPivot("stl_status"), {
        data: {
            start,
            end,
            datetype,
            currency: state.common.currency,
            q: q.toString(true)
        }
    });
};

export const FETCH_CHARGEBACK_RATE_DATA = function({ start, end, q }) {
    const state = store.getState();
    
    return request(v2.chargebacks.byPivot("method"), {
        data: {
            start,
            end,
            datetype: state.common.date_range.datetype,
            currency: state.common.currency,
            q: q.toString(true)
        }
    });
};

export const FETCH_FEES_TYPE_DATA = function({ start, end, q }) {
    const state = store.getState();
    
    return request(v2.fees.byPivot("fee_type"), {
        data: {
            start,
            end,
            datetype: state.common.date_range.datetype,
            currency: state.common.currency,
            q: q.toString(true)
        }
    });
};

export const FETCH_PIVOT_TABLE_DATA = function({
    apiRoot, pivots, start, end, q
}) {
    const state = store.getState();

    return request(v2[apiRoot].byPivot(pivots), {
        data: {
            start,
            end,
            datetype: state.common.date_range.datetype,
            currency: state.common.currency,
            q: q.toString(true)
        }
    });
};

export const FETCH_FRAUD_3DS_DATA = function({ start, end, q, isPSD2 }) {
    const state = store.getState();
    return request(isPSD2
        ? v2.psd2.byPivot("auth_method")
        : v2.fraud.byPivot("auth_method"), {
        data: {
            start,
            end,
            datetype: "activity",
            currency: state.common.currency,
            q: q.toString(true)
        }
    });
};

export const FETCH_ANALYTICS_DATA2 = function({
    url, start, end, dt, c, q, f = "day"
}) {
    return request(url, {
        data: {
            start,
            end,
            datetype: dt,
            currency: c,
            freq: f,
            q: q.toString(true)
        }
    });
};
